import { signal } from '@preact/signals';
import { api } from './auth.js';

export const platformUpdatesCount = signal(0);

export async function loadPlatformUpdatesCount() {
  try {
    const data = await api('/api/updates/unread-count');
    platformUpdatesCount.value = data.count ?? 0;
  } catch {
    // Silent fail
  }
}

export async function markAllUpdatesRead() {
  try {
    await api('/api/updates/mark-all-read', { method: 'POST' });
    platformUpdatesCount.value = 0;
  } catch {
    // Silent fail
  }
}
